import {Locales} from '@netx/core-next/locales';

export const cmsBlockTypes = [
	'asset',
	'carousel',
	'savedCart',
	'category',
	'categoryAssetList',
	'html',
	'divider',
	// 'savedSearch', // not a thing in 8.6
];

export let blocks = {
	types: Locales((i18n) => ({
		asset: i18n('i18n.asset'),
		carousel: i18n('i18n.carousel'),
		savedCart: i18n('i18n.savedCart'),
		category: i18n('i18n.category'),
		categoryAssetList: i18n('i18n.categoryAssetList'),
		html: i18n('i18n.html'),
		divider: i18n('i18n.divider'),
		// savedSearch: 'savedSearch', // not a thing in 8.6
	})),
	assetTypes: {
		cmsHero: 'Hero',
		cmsPageLink: 'Page link',

		singleAssetPreview: 'Preview',
		singleAssetOriginal: 'Original',
		singleAssetOriginalZoom: 'Original Zoom linked',
		singleAssetDownload: 'Download',
		singleAssetListItem: 'List Item',
		singleAssetPreviewDownload: 'Preview download',
	},
};

export let links = {
	types: {
		action: 'action',
		asset: 'asset',
		category: 'category',
		page: 'page',
		url: 'url',
	},
};

export let templates = {
	names: {
		template1: 'Template 1',
		template2: 'Template 2',
		template3: 'Template 3',
		template4: 'Template 4',
		template5: 'Template 5',
		template6: 'Template 6',
		template7: 'Template 7',
		template8: 'Template 8',
		template9: 'Template 9',
		template10: 'Template 10',
		template11: 'Template 11',
	},
	// default template blocks (from "Clean Page Templates.pdf")
	blocks: {
		template1: [
			'html',
			'asset',
			'asset',
			'asset',
			'asset',
			'asset',
			'asset',
			'asset',
		],
		template2: ['html', 'asset', 'html', 'asset', 'html', 'asset'],
		template3: ['html', 'asset', 'html', 'html', 'html', 'html'],
		template4: ['html', 'asset', 'html', 'html'],
		template5: ['html', 'asset', 'html', 'html'],
	},
};

export default {
	blocks: blocks,
	links: links,
	templates: templates,
};
